import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router-dom";
import UserService from "../../services/userService";
import { useState } from "react";

export const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const email = searchParams.get("email") ?? "";
  const { t } = useTranslation();
  const [newPassword, setNewPassword] = useState("");
  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if (!newPassword || !token || !email) {
      return;
    }
    UserService.resetPassword({
      token: token ?? "",
      newPassword,
      email: email ?? "",
    })
      .then(() => {
        alert(t("Password reset successfully"));
        window.location.href = "/";
      })
      .catch((error) => {
        console.error(error);
        alert(t("Failed to reset password"));
      });
  };
  return (
    <div className="mx-auto flex h-[80vh] items-center justify-center">
      <form onSubmit={handleSubmit} className="mt-4 sm:w-[30rem]">
        <h3 className="title-popup mb-2 font-semibold leading-[2.5537rem] sm:mb-8">
          {t("Reset password")}
        </h3>
        <input
          type="text"
          id="email"
          name="email"
          placeholder={t("Email")}
          value={email}
          readOnly
          disabled
          className="mb-2.5 h-[3.125rem] w-full rounded-[0.625rem] border p-2 sm:mb-[1.25rem]"
        />

        <input
          type="password"
          id="newPassword"
          name="newPassword"
          placeholder={t("New password")}
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
          className="mb-2.5 h-[3.125rem] w-full rounded-[0.625rem] border p-2 sm:mb-[1.25rem]"
        />
        <div className="flex gap-4">
          <button
            type="submit"
            disabled={!newPassword}
            className={`text-1 mb-6 mt-6 h-[3.125rem] w-full rounded-full p-2 font-semibold text-white ${
              !newPassword ? "bg-[#BFC5C9]" : "bg-[#232323]"
            }`}
          >
            {t("Reset")}
          </button>
        </div>
      </form>
    </div>
  );
};
